import { render, staticRenderFns } from "./AccountInReview.vue?vue&type=template&id=4a816218&"
import script from "./AccountInReview.vue?vue&type=script&lang=ts&"
export * from "./AccountInReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports